import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step3 } from '../../../../../shared/models/component-messages/mapaAT/step3';
import { ObjectToJsonStepperCreatorService } from '../../../../../shared/services/object-to-json-stepper-creator.service';
import { TypeCrJugement } from '../../models/TypeCrJugement';

@Component({
  selector: 'app-step3',
  templateUrl: './step3.component.html'
})
export class Step3Component implements OnInit {

  @Input() criteresAttribution: TypeCrJugement;
	@Input() parentForm: FormGroup;
	@Input() disabled: boolean;
	@Input() uid = '';
	@Input() linkForRouter: string;

  public step3 = new Step3();

  constructor(public objectToJsonStepperCreatorService: ObjectToJsonStepperCreatorService) { }

  ngOnInit(): void {
  }

  public getUid() {
    return this.uid + "_SepSep_AttributionFromMAPA";
  }
}
